const initializeNestwistProductShop = (root = document) => {
  root.querySelectorAll('[data-nestwist-product-shop]').forEach((container) => {
    if (container.dataset.initialized === 'true') return;
    container.dataset.initialized = 'true';

    const select = container.querySelector('[data-variant-select]');
    if (!select) return;

    const updateVariant = () => {
      const option = select.selectedOptions[0];
      const price = container.querySelector('[data-product-price]');
      const button = container.querySelector('[data-add-to-cart]');
      const label = container.querySelector('[data-add-label]');
      const acceleratedCheckout = container.querySelector('[data-accelerated-checkout]');
      const available = option?.dataset.available === 'true';

      if (price && option) {
        const comparePrice = option.dataset.comparePrice;
        price.replaceChildren();

        const currentPrice = document.createElement('span');
        currentPrice.textContent = option.dataset.price;
        price.append(currentPrice);

        if (comparePrice) {
          const compare = document.createElement('s');
          compare.textContent = comparePrice;
          price.append(compare);
        }
      }

      if (button) button.disabled = !available;
      if (acceleratedCheckout) acceleratedCheckout.hidden = !available;
      if (label && button) {
        label.textContent = available ? button.dataset.availableLabel : button.dataset.soldOutLabel;
      }
    };

    select.addEventListener('change', updateVariant);
    updateVariant();
  });
};

initializeNestwistProductShop();
document.addEventListener('shopify:section:load', (event) => initializeNestwistProductShop(event.target));
